import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  Instagram,
  Facebook,
  Youtube,
  Whatsapp,
  Envelope,
  Phone,
  GeoAlt,
  Clock,
  PersonVcard,
} from 'react-bootstrap-icons';
import logo from '../../../assets/images/logo 250.png';
import PrivacyModal from '../../common/privacyModal/PrivacyModal';
import TermsModal from '../../common/termsModal/TermsModal';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: Instagram,
      href: 'https://www.instagram.com/annalisa.picca',
      label: 'Instagram',
    },
    {
      icon: Facebook,
      href: 'https://www.facebook.com/anna.journal.56',
      label: 'Facebook',
    },
    {
      icon: Youtube,
      href: 'https://www.youtube.com/@benessere_posturale',
      label: 'YouTube',
    },
    {
      icon: Whatsapp,
      href: 'https://wa.me/3757481380',
      label: 'WhatsApp',
    },
  ];

  return (
    <>
      <footer className="custom-footer">
        <Container>
          <Row className="footer-content">
            {/* Brand Section */}
            <Col lg={3} md={6} className="footer-section">
              <div className="footer-brand">
                <img
                  src={logo}
                  alt="Benessere Posturale Logo"
                  height="50"
                  className="footer-logo mb-3"
                />
                <h5 className="footer-brand-text">Benessere Posturale</h5>
                <p className="footer-tagline">
                  Migliora la tua postura, ritrova il benessere
                </p>
              </div>
            </Col>

            {/* Contact Section */}
            <Col lg={3} md={6} className="footer-section">
              <h6 className="footer-section-title">Contatti</h6>
              <div className="footer-contact">
                <div className="contact-item">
                  <Envelope size={18} className="contact-icon" />
                  <a href="mailto:info@benessereposturale.it">
                    info@benessereposturale.it
                  </a>
                </div>
                <div className="contact-item">
                  <Phone size={18} className="contact-icon" />
                  <a
                    href="https://wa.me/3757481380"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +39 375 748 1380
                  </a>
                </div>
                <div className="contact-item">
                  <GeoAlt size={18} className="contact-icon" />
                  <span>Milano, Italia</span>
                </div>
                <div className="contact-item">
                  <Clock size={18} className="contact-icon" />
                  <span>Lun-Ven: 9:00-18:00</span>
                </div>
                <div className="contact-item">
                  <PersonVcard size={18} className="contact-icon" />
                  <span>P.IVA 13991250963</span>
                </div>
              </div>
            </Col>

            {/* Quick Links Section */}
            <Col lg={3} md={6} className="footer-section">
              <h6 className="footer-section-title">Link Utili</h6>
              <div className="footer-links">
                <a href="/servizi" className="footer-link">
                  Servizi offerti
                </a>
                <a href="/rimettiti-al-centro" className="footer-link">
                  Rimettiti al centro
                </a>
                <a href="/in-regalo" className="footer-link">
                  In regalo
                </a>
                <a href="/chi-sono" className="footer-link">
                  Chi sono
                </a>
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#privacyModal"
                  className="footer-link"
                >
                  Privacy Policy
                </a>

                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#termsModal"
                  className="footer-link"
                >
                  Termini di Servizio
                </a>
              </div>
            </Col>

            {/* Social Section */}
            <Col lg={3} md={6} className="footer-section">
              <h6 className="footer-section-title">Seguimi</h6>
              <div className="footer-social">
                <div className="social-icons">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                      aria-label={social.label}
                    >
                      <social.icon size={22} />
                    </a>
                  ))}
                </div>
                <p className="social-description">
                  Resta aggiornato sui consigli di benessere posturale
                </p>
              </div>
            </Col>
          </Row>

          {/* Copyright Section */}
          <Row className="footer-bottom">
            <Col className="text-center">
              <div className="footer-copyright">
                <p>
                  © {currentYear} Benessere Posturale - Tutti i diritti
                  riservati
                </p>
                <p className="footer-madeby">
                  Made with ❤️ by{' '}
                  <a
                    href={
                      'https://www.linkedin.com/in/alessio-popolo-066a38119/'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Axel Design
                  </a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <PrivacyModal />
      <TermsModal />
    </>
  );
};

export default Footer;
